<template>
  <div>
    <page-title title="Billing Settings"></page-title>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle';

export default {
  components: { PageTitle }
}
</script>

<style lang="scss" scoped>

</style>